import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=48b29153&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b29153')) {
      api.createRecord('48b29153', component.options)
    } else {
      api.reload('48b29153', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=48b29153&", function () {
      api.rerender('48b29153', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2D83EQnMSEvQX/JS/comp/FavElement.vue"
export default component.exports